<div class="cmdk-appprev">
  <div class="cmdk-appprev__head">
    <span class="cmdk-appprev__mark" aria-hidden="true">
      <im-app-brand-icon
        [imageUrl]="link()?.customIcon"
        [svgPath]="link()?.catalogSvg"
        [fillRule]="link()?.catalogFillRule"
        [fallbackIcon]="link()?.icon || item().icon || 'globe'"
        [size]="30" />
    </span>
    <div class="cmdk-appprev__ident">
      <h3 class="cmdk-appprev__title">{{ item().title }}</h3>
      <p class="cmdk-appprev__host">{{ item().subtitle }}</p>
    </div>
  </div>

  <div class="cmdk-appprev__tags">
    @if (item().category; as category) {
      <paper-tag size="sm" [label]="category" />
    }
    @if (scopeLabel(); as scope) {
      <paper-tag size="sm" [label]="scope" />
    }
  </div>

  <!-- The admin's own words, when there are any. Only organisation links carry
       a description — the personal-link type has no such field. -->
  @if (link()?.description; as description) {
    <p class="cmdk-appprev__desc">{{ description }}</p>
  }

  <p class="cmdk-appprev__dest">{{ destination() }}</p>

  <div class="cmdk-appprev__actions">
    <paper-button
      intent="primary"
      size="sm"
      [icon]="item().actionId ? 'arrow-right' : 'arrow-up-right'"
      iconPosition="right"
      data-testid="cmdk-app-open"
      (click)="activated.emit()">
      {{ openLabel() }}
    </paper-button>
    <paper-kbd keys="↵" label="Enter" size="sm" />
  </div>
</div>
